/*=============================================== Flexbox ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import { stringifyPx } from "js-utils-julseb";
import Variables from "./Variables";
/*==================== Component ====================*/
var Flexbox = function (_a) {
    var inline = _a.inline, direction = _a.direction, wrap = _a.wrap, justify = _a.justify, align = _a.align, gap = _a.gap, rowGap = _a.rowGap, columnGap = _a.columnGap, padding = _a.padding, children = _a.children, props = __rest(_a, ["inline", "direction", "wrap", "justify", "align", "gap", "rowGap", "columnGap", "padding", "children"]);
    return (React.createElement(Container, __assign({ "$inline": inline, "$direction": direction, "$wrap": wrap, "$justify": justify, "$align": align, "$gap": gap, "$rowGap": rowGap, "$columnGap": columnGap, "$padding": padding }, props), children));
};
export default Flexbox;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: ", ";\n    flex-direction: ", ";\n    flex-wrap: ", ";\n    justify-content: ", ";\n    align-items: ", ";\n    gap: ", ";\n    column-gap: ", ";\n    row-gap: ", ";\n    padding: ", ";\n"], ["\n    display: ", ";\n    flex-direction: ", ";\n    flex-wrap: ", ";\n    justify-content: ", ";\n    align-items: ", ";\n    gap: ", ";\n    column-gap: ", ";\n    row-gap: ", ";\n    padding: ", ";\n"])), function (_a) {
    var $inline = _a.$inline;
    return ($inline ? "inline-flex" : "flex");
}, function (_a) {
    var $direction = _a.$direction;
    return $direction;
}, function (_a) {
    var $wrap = _a.$wrap;
    return $wrap;
}, function (_a) {
    var $justify = _a.$justify;
    return $justify;
}, function (_a) {
    var $align = _a.$align;
    return $align;
}, function (_a) {
    var $gap = _a.$gap;
    return $gap === "xxl"
        ? Variables.Spacers.XXL
        : $gap === "xl"
            ? Variables.Spacers.XL
            : $gap === "l"
                ? Variables.Spacers.L
                : $gap === "m"
                    ? Variables.Spacers.M
                    : $gap === "s"
                        ? Variables.Spacers.S
                        : $gap === "xs"
                            ? Variables.Spacers.XS
                            : $gap === "xxs"
                                ? Variables.Spacers.XXS
                                : $gap
                                    ? stringifyPx($gap)
                                    : "";
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return $columnGap === "xxl"
        ? Variables.Spacers.XXL
        : $columnGap === "xl"
            ? Variables.Spacers.XL
            : $columnGap === "l"
                ? Variables.Spacers.L
                : $columnGap === "m"
                    ? Variables.Spacers.M
                    : $columnGap === "s"
                        ? Variables.Spacers.S
                        : $columnGap === "xs"
                            ? Variables.Spacers.XS
                            : $columnGap === "xxs"
                                ? Variables.Spacers.XXS
                                : $columnGap
                                    ? stringifyPx($columnGap)
                                    : "";
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return $rowGap === "xxl"
        ? Variables.Spacers.XXL
        : $rowGap === "xl"
            ? Variables.Spacers.XL
            : $rowGap === "l"
                ? Variables.Spacers.L
                : $rowGap === "m"
                    ? Variables.Spacers.M
                    : $rowGap === "s"
                        ? Variables.Spacers.S
                        : $rowGap === "xs"
                            ? Variables.Spacers.XS
                            : $rowGap === "xxs"
                                ? Variables.Spacers.XXS
                                : $rowGap
                                    ? stringifyPx($rowGap)
                                    : "";
}, function (_a) {
    var $padding = _a.$padding;
    return $padding === "xxl"
        ? Variables.Spacers.XXL
        : $padding === "xl"
            ? Variables.Spacers.XL
            : $padding === "l"
                ? Variables.Spacers.L
                : $padding === "m"
                    ? Variables.Spacers.M
                    : $padding === "s"
                        ? Variables.Spacers.S
                        : $padding === "xs"
                            ? Variables.Spacers.XS
                            : $padding === "xxs"
                                ? Variables.Spacers.XXS
                                : $padding
                                    ? stringifyPx($padding)
                                    : "";
});
var templateObject_1;
